import React from 'react';
import { connect } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { APP_BASE_URL_2, INVENTORY_API_BASE_URL_2, ISC_API_BASE_URL_2, ORG_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Ax from '../../../components/hoc/Ax';
import tapIcon from '../../../services/TapIcon';
import { Modal } from 'bootstrap';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import { toast } from 'react-toastify';
import AppBaseComponent from '../../../components/AppBaseComponent';
import uuid from 'react-uuid';
import Vendor from '../includes/Vendor';
import InputCustomerSearch from '../../includes/ui/InputCustomerSearch';

class OriginEditModal extends AppBaseComponent {
    
    constructor(props) {
        super(props);

        this.manualAddressInitialState    =   { 
            address1                        :   '',
            address2                        :   '',
            landmark                        :   '',
            city                            :   '',
            country_id                      :   '',
            state_id                        :   null,
            district_name                   :   null,
            pincode                         :   null,
            gstin                           :   '',
        }

        this.state                      =   {
            editFormSubmitting              :   false,
            loading_form                    :   false,
            addNewDistrict                  :   false,
            addNewPinCode                   :   false,

            origin_detail_loading           :   false,

            originDetailsLoading            :   false,
            originVendorDetailsLoading      :   false,
            originVendorDetails             :   null,
            originVendorAddressList         :   [],
            originSelectedVendorAdress      :   null,
            originSearchedVendor            :   null,
            searchedOriginCustomer          :   null,

            manualAddress                   :   {...this.manualAddressInitialState},
            allStateList                    :   [],
            allCountryList                  :   [],
            allDistrictList                 :   [],
            allPincodeList                  :   [],
            
            all_warehouses                  :   [],
            modalType                       :   '', 
            logisticDetail                  :   {},   
            transport_days                  :   '',    
        };
       
        this.modalId            =   uuid();   
        this.logisticUrl        =   APP_BASE_URL_2      +   '/logistic';
        this.stateListUrl       =   ORG_API_BASE_URL_2  +   '/state_list';
        this.districtListUrl    =   ORG_API_BASE_URL_2  +   '/district_list';
        this.pincodesUrl        =   ORG_API_BASE_URL_2  +   '/pincodes';
        this.warehouseUrl       =   ISC_API_BASE_URL_2  +    '/warehouse';
        this.customerURL        =   INVENTORY_API_BASE_URL_2 + '/customer';   
       
    }
    
  
    componentDidMount(){
        this.addModal                  =   new Modal(document.getElementById(this.modalId), {keyboard: false, backdrop :false});
    }

    showModalInit           =   (type)  =>  {  
        const logisticDetail = this.props.logisticDetail;
        this.setState({
            loading_form    :   true,
            modalType       :   type,
            logisticDetail  :   {...logisticDetail},
            searchVendor    :   [],
        }, () => {
            this.addModal.show();
        });

        if(logisticDetail.origin_type === 'vendor') {
            this.setState({
                originSearchedVendor:   logisticDetail.origin_vendor_id && {value : logisticDetail.origin_vendor_id, display_label : logisticDetail.origin_type_detail ? `${logisticDetail.origin_type_detail.name} (${logisticDetail.origin_type_detail.code})` : ''}
            })
        }

        if(logisticDetail.origin_type === 'customer') {
            this.setState({
                searchedOriginCustomer:   logisticDetail.origin_customer_id && [{value : logisticDetail.origin_customer_id, label : logisticDetail.origin_type_detail && `${logisticDetail.origin_type_detail.name}`}]
            })
        }


        if(logisticDetail.origin_type === 'manual_entry') {
            this.setState({
                manualAddress   :   {...logisticDetail.display_origin_address},
            });
        }

        HttpAPICall.withAthorization('GET', `${this.logisticUrl}/form_data`, this.props.access_token, null, null, (response) => {
            const formData                   =   response.data;
            this.setState({
                all_warehouses              :    this.props.all_warehouses.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` }}),  
                allCountryList             :   formData && formData.country ?  formData.country.map((s) => { return {value: s.id, label: s.name}; }) : [],     
            });
        }).then(() => { this.setState({ loading_form: false}) });
    }

    countryChangeHandler              =        (selected_country)    =>  {
        if (selected_country) {
            let selectedCountry;
            if(selected_country.value){
                selectedCountry = selected_country.value;
            }else{
                selectedCountry = selected_country
            }
            HttpAPICall.withAthorization('GET', this.stateListUrl, this.props.access_token, {country_id : selectedCountry}, null, (response) => {
                this.setState({
                    allStateList                :   response.data && response.data.length > 0 ?  response.data.map((s) => { return {value: s.id, label: s.name}; })  : [],
                    allOperationsStateList      :   response.data && response.data.length > 0 ?  response.data.map((s) => { return {value: s.id, label: s.name}; })  : [],
                    manualAddress               :    {...this.state.manualAddress,state_id: '',district_name : '',pincode:''},
                    addNewDistrict              :   false ,
                    addNewPinCode               :   false 
                });
            });
        }
        
    }

    //FUNCTION TO GET DISTRICT LIST ON SELECTING STATE
    stateChangeHandler              =        (selected_state)    =>  {
        if (selected_state) {
            let params;
            if(selected_state.length > 0){
                let state_ids = selected_state.map(i => i.value)
                params = {state_ids : state_ids}
            }else{
                params = {state_ids : [selected_state.value ? selected_state.value : selected_state]}
            }
            HttpAPICall.withAthorization('GET', this.districtListUrl, this.props.access_token, {...params}, null, (response) => {
                this.setState({
                    allDistrictList             :  response.data.map((s) => { return {value: s.name, label: s.name}; }),
                    addNewDistrict              :   response.data && response.data.length > 0 ? false : true,
                    addNewPinCode               :   response.data && response.data.length > 0 ?  false : true,
                    manualAddress               :    {...this.state.manualAddress,pincode:''}
                });
            });
        }
    }

      //FUNCTION TO GET PINCODE LIST ON SELECTING DISTRICT
      districtChangeHandler              =        (selected_district)    =>  {
        if (selected_district) {
            let selectedDistrict;
            if(selected_district.value){
                selectedDistrict = selected_district.value;
            }else{
                selectedDistrict = selected_district
            }
            let params = {district_name : selectedDistrict,state_id:this.state.manualAddress.state_id}
            HttpAPICall.withAthorization('GET', this.pincodesUrl, this.props.access_token, params, null, (response) => {
                this.setState({
                    allPincodeList              :   response.data.map((s) => { return {value: s.pincode, label: s.pincode}; }),
                    addNewPinCode               :   response.data && response.data.length > 0 ? false : true,
                });
            });
        }
    }

    //********************** Handle Origin Type Radio Button *******************/
    handleOriginType                  =   (origin_type) => {
        if(origin_type === "warehouse") {
            this.setState({
                logisticDetail         :   {
                    ...this.state.logisticDetail,
                    origin_type             :   origin_type,
                    origin_vendor_id        :   null,
                    origin_customer_id      :   null,
                    origin_address          :   null,
                    display_origin_address  :   null,
                },
                originManualChecked         :   false,
            });
        }else if(origin_type === "vendor") {
            this.setState({
                logisticDetail         :   {
                    ...this.state.logisticDetail,
                    origin_type             :   origin_type,
                    origin_warehouse_id     :   null,
                    origin_customer_id      :   null,
                    origin_address          :   null,
                    display_origin_address  :   null,
                },
                originManualChecked         :   false,
            });
        }else if(origin_type === "customer") {
            this.setState({
                logisticDetail         :   {
                    ...this.state.logisticDetail,
                    origin_type             :   origin_type,
                    origin_vendor_id        :   null,
                    origin_warehouse_id     :   null,
                    origin_address          :   null,
                    display_origin_address  :   null,
                },
                originManualChecked         :   false,
            });
        }else {
            this.setState({
                logisticDetail         :   {
                    ...this.state.logisticDetail,
                    origin_type             :   origin_type,
                    origin_vendor_id        :   null,
                    origin_warehouse_id     :   null,
                    origin_customer_id      :   null,
                    origin_address          :   null,
                    display_origin_address  :   null,
                },
            });
        }
    }

    //submit add Origin Form
    editLogisticFormSubmit      =   (e) =>  {
        e.preventDefault();
        this.setState({editFormSubmitting : true});
 
         const data = {...this.state.logisticDetail};
 
         HttpAPICall.withAthorization('PUT', `${this.logisticUrl}/edit`, this.props.access_token, null, data, (response) => {
             toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
             this.props.getLogisticViewDetails(this.state.logisticDetail.transaction_id);
             this.addModal.hide();
         }).then(() => this.setState({ editFormSubmitting: false }));
 
     }

    //********************Handle Origin VENDOR ******************************* */
    handleOriginVendor     =   (selectedOption,edit=false) => {
        this.setState({
            logisticDetail             :   {
                ...this.state.logisticDetail,
                origin_vendor_id            :   selectedOption ? selectedOption.value : null
            },
            originVendorDetails             :   selectedOption ? selectedOption : null,
            searchedVendorAdressList        :   selectedOption && selectedOption.vendor ? selectedOption.vendor.addressList : null,
            originSelectedVendorAdress      :   selectedOption && selectedOption.vendor && edit == false ? selectedOption.vendor.addressList[0] : this.state.originSelectedVendorAdress,
            originSearchedVendor   :     selectedOption ? selectedOption : null
        },() => {
            if(edit == false){
                this.setState({
                   gst_not_applicable          :      this.state.originSelectedVendorAdress && this.state.originSelectedVendorAdress.country_id !== 99 ? 'Y' : 'N'
                })
           }
        })
    }

    //********************GET Origin VENDOR DETAILS ******************************* */
    getOriginVendorDetails     =   (id,edit=false) =>  {

        if(id) {
            this.setState({originVendorDetailsLoading : true})
            HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/vendor' + '/' + id, this.props.access_token, null, null, (response) => {
                let originSelectedVendorAdress   =   response.data.data && response.data.data.addressList ? response.data.data.addressList[0] : null;

                const address1      =   originSelectedVendorAdress ? originSelectedVendorAdress.address1 : null; 
                const address2      =   originSelectedVendorAdress.address2; 
                const landmark      =   originSelectedVendorAdress ? originSelectedVendorAdress.landmark : null; 
                const city          =   originSelectedVendorAdress ? originSelectedVendorAdress.city : null;  
                const country_id    =   originSelectedVendorAdress ? originSelectedVendorAdress.country_id : null; 
                const state_id      =   originSelectedVendorAdress ? originSelectedVendorAdress.state_id : null; 
                const district_id   =   originSelectedVendorAdress ? originSelectedVendorAdress.district_id : null; 
                const gstin         =   originSelectedVendorAdress ? originSelectedVendorAdress.gstin : null; 
                const pincode       =   originSelectedVendorAdress ? originSelectedVendorAdress.pincode : null; 
                
                const logisticDetail    =   this.state.logisticDetail;

                this.setState({
                    originVendorDetails            :   response.data.data,
                    originVendorAddressList        :   response.data.data.addressList,
                    originSelectedVendorAdress     :   edit == false ? originSelectedVendorAdress : this.state.originSelectedVendorAdress,

                    logisticDetail                 :   {
                        id              :   logisticDetail.id,
                        transaction_id  :   logisticDetail.transaction_id,
                        origin_vendor_id : id,
                        origin_type : 'vendor', 
                        origin_address : {address1, address2, landmark, city, country_id, state_id, district_id, pincode, gstin},
                    }
                });
            }).then(() => {
                this.setState({ originVendorDetailsLoading : false });
                this.setState({gstTypeName :  this.state.originSelectedVendorAdress && this.state.warehouseDetail && this.state.originSelectedVendorAdress.state_id == this.state.warehouseDetail.state_id ? 'GST' : 'IGST'});
            });
        }
    }

    //********************GET WAREHOUSE DETAILS API ******************************* */
    getWarehouseDetails             =       (selectedOption)        =>          {

        if(selectedOption){
            let  id = selectedOption.value ? selectedOption.value : selectedOption
            
            this.setState({
                origin_detail_loading       :   true
            }); 

            HttpAPICall.withAthorization('GET', this.warehouseUrl + '/' + id, this.props.access_token, {}, {}, (resp) => {
                let respData = resp.data;
                const address1      =   respData.data.address1; 
                const address2      =   respData.data.address2; 
                const landmark      =   respData.data.landmark; 
                const city          =   respData.data.city;   
                const country_id    =   respData.data.country_id; 
                const state_id      =   respData.data.state_id; 
                const district_id   =   respData.data.district_id; 
                const gstin         =   respData.data.gstin; 
                const pincode       =   respData.data.pincode; 

                const country       =   respData.data.country?.name; 
                const state         =   respData.data.state_name; 
                const district      =   respData.data.district_name; 

                const logisticDetail    =   this.state.logisticDetail;

                this.setState({
                    logisticDetail                  :   {
                        id      :   logisticDetail.id,
                        transaction_id  :   logisticDetail.transaction_id,
                        origin_warehouse_id : id,
                        origin_type : 'warehouse',
                        origin_address : {address1, address2, landmark, city, country_id, state_id, district_id, pincode, gstin},
                        display_origin_address : {address1, address2, landmark, city, country, state, district, pincode, gstin}
                    },
                    origin_detail_loading           :   false,
                });
            });
        }else{
            this.setState({
                origin_detail_loading           :   false,
            }); 
        }
    }

    //********************GET CUSTOMER DETAILS API ******************************* */
    getCustomerDetail       =   (selectedOption) => {
        if(selectedOption){
            const  id = selectedOption.value ? selectedOption.value : selectedOption;
            this.setState({
                origin_detail_loading       :   true
            }); 

            HttpAPICall.withAthorization('GET', this.customerURL + '/' + id, this.props.access_token, {}, {}, (resp) => {
                const respData          =   resp.data.data;
                const customerAddress   =   respData.addressList[0];     

                const address1      =   customerAddress.address1; 
                const address2      =   customerAddress.address2; 
                const landmark      =   customerAddress.landmark; 
                const city          =   customerAddress.city;   
                const country_id    =   customerAddress.country_id; 
                const state_id      =   customerAddress.state_id; 
                const district_id   =   customerAddress.district_id; 
                const gstin         =   customerAddress.gstin; 
                const pincode       =   customerAddress.pincode; 

                const country       =   customerAddress.country_name; 
                const state         =   customerAddress.state_name; 
                const district      =   customerAddress.district_name; 

                const logisticDetail    =   this.state.logisticDetail;


                this.setState({
                    origin_detail_loading           :   false,
                    logisticDetail                  :   {
                        id                          :   logisticDetail.id,
                        transaction_id              :   logisticDetail.transaction_id,
                        origin_customer_id          : id,
                        origin_type                 : 'customer',
                        origin_address              : {address1, address2, landmark, city, country_id, state_id, district_id, pincode, gstin},
                        display_origin_address      : {address1, address2, landmark, city, country, state, district, pincode, gstin}
                    },
                }); 
            });
        }else{
            this.setState({
                origin_detail_loading           :   false,
            }); 
        }
    }
   

    //*********************************ITEM ADD JSX*********************** */
    modalJsx                     =   ()  =>  {
        const logisticDetail            =   this.state.logisticDetail;
        return (
            <div className="modal fade" id={this.modalId} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content  ">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addModalLabel">Edit {this.state.modalType}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <div className="modal-body ">
                            {
                            this.state.loading_form 
                            ? 
                            <Loader/>
                            : 
                            <form onSubmit={this.editLogisticFormSubmit} id="editOriginLogisticForm" method="post" encType="multipart/form-data">
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-2">
                                        <label htmlFor="site_id" className="form-label ">Origin Type</label>
                                    </div>
                                    <div className="col-sm-10">
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <input
                                                    name="origin_type"
                                                    type="radio"
                                                    
                                                    value={"warehouse"}
                                                    onChange={(e) => this.handleOriginType('warehouse')}
                                                    checked={logisticDetail.origin_type === 'warehouse' ? true : false}
                                                    className="form-check-input "
                                                    id="origin_warehouse"
                                                />
                                                <label className="form-check-label mx-2" htmlFor="origin_warehouse">Warehouse</label>
                                            </div>
                                            <div className="col-sm-3">
                                                <input
                                                    name="origin_type"
                                                    type="radio"
                                                    value={"vendor"}
                                                    onChange={(e) => this.handleOriginType('vendor')}
                                                    className="form-check-input"
                                                    checked={logisticDetail.origin_type === 'vendor' ? true : false}
                                                    id="origin_vendor"
                                                />
                                                <label className="form-check-label mx-2" htmlFor="origin_vendor">Vendor</label>
                                            </div>
                                            <div className="col-sm-3">
                                                <input
                                                    name="origin_type"
                                                    type="radio"
                                                    value={"customer"}
                                                    onChange={(e) => this.handleOriginType('customer')}
                                                    className="form-check-input"
                                                    checked={logisticDetail.origin_type === 'customer' ? true : false}
                                                    id="origin_customer"
                                                />
                                                <label className="form-check-label mx-2" htmlFor="origin_customer">Customer</label>
                                            </div>
                                            <div className="col-sm-3">
                                                <input
                                                    name="origin_type"
                                                    type="radio"
                                                    value={"manual_entry"}
                                                    className="form-check-input "
                                                    id="origin_manual_entry"
                                                    onChange={(e) => this.handleOriginType('manual_entry')}
                                                    checked={logisticDetail.origin_type === 'manual_entry' ? true : false}
                                                />
                                                <label className="form-check-label mx-2" htmlFor="origin_manual_entry">Manual Entry</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    logisticDetail.origin_type === 'warehouse' && 
                                    <div className="row align-items-center my-3">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-6">
                                            <TapSelect
                                                changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'logisticDetail', 'origin_warehouse_id'); this.getWarehouseDetails(selectedOption);}}
                                                options={this.state.all_warehouses}
                                                isSearchable={true}
                                                isClearable={true}
                                                value={this.state.all_warehouses.find(m => m.value == logisticDetail.origin_warehouse_id)}
                                                placeholder="Select Warehouse"
                                            />
                                        </div>
                                    </div>
                                }
                                {
                                    logisticDetail.origin_type === 'vendor' &&
                                    <div className="row align-items-center my-3">
                                    <div className="col-sm-2"></div>
                                        <div className="col-sm-6">
                                            <Vendor
                                                labelDisable={true}
                                                showAddVendor={false}
                                                vendorDetails={this.state.originVendorDetails}
                                                details_loading={this.state.originDetailsLoading}
                                                vendorAddressList={this.state.originVendorAddressList}
                                                vendor_details_loading={this.state.originVendorDetailsLoading}
                                                selectedVendorAdress={this.state.originSelectedVendorAdress}
                                                onChange={this.handleOriginVendor}
                                                getVendorDetails={this.getOriginVendorDetails}
                                                searchedVendor={this.state.originSearchedVendor}
                                                // changeAddressHandler={this.changeAddressHandler}
                                            />
                                        </div>
                                    </div>
                                }
                                {    
                                    logisticDetail.origin_type === 'customer' &&
                                    <div className="row align-items-center my-3">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-6">
                                            <InputCustomerSearch
                                                changeEvent={(selectedOption) => {
                                                    this.tapSelectChange(selectedOption, 'logisticDetail', 'origin_customer_id');
                                                    this.getCustomerDetail(selectedOption);
                                                    this.setState({ searchedOriginCustomer: selectedOption ? selectedOption : null });
                                                }}
                                                menuPlacement="top"
                                                value={this.state.searchedOriginCustomer}
                                            />
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.origin_detail_loading 
                                    ?
                                    <Loader/>
                                    :
                                    (logisticDetail.display_origin_address && ['warehouse', 'customer'].includes(logisticDetail.origin_type)) 
                                    ?
                                    <div className="row align-items-center mt1 pb-2">
                                        <div className="offset-2 col-sm-8">
                                            <label className='form-label'>Address : 
                                            {
                                                logisticDetail.display_origin_address.address1 ? `${logisticDetail.display_origin_address.address1}, ` : ''
                                            }
                                            {
                                                logisticDetail.display_origin_address.address2 ? `${logisticDetail.display_origin_address.address2}, ` : ''
                                            }
                                            {
                                                logisticDetail.display_origin_address.landmark ? `${logisticDetail.display_origin_address.landmark}, ` : ''
                                            }
                                            {
                                                logisticDetail.display_origin_address.city ? `${logisticDetail.display_origin_address.city}, ` : ''
                                            }
                                            </label><br />
                                            <label className='form-label'>Origin of Supply : 
                                                <span>
                                                {
                                                    logisticDetail.display_origin_address.state ? logisticDetail.display_origin_address.state : ''
                                                }
                                                </span>
                                            </label> <br />
                                            <label className='form-label'>GSTIN : 
                                                <span>
                                                {
                                                    logisticDetail.display_origin_address.gstin ? logisticDetail.display_origin_address.gstin : ''
                                                }
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    :
                                    (
                                    (logisticDetail.origin_type === 'vendor' && logisticDetail.display_origin_address)
                                    ?
                                    <div className="row align-items-center mt1 pb-2">
                                        <div className="offset-2 col-sm-8">
                                            <label className='form-label'>Address : 
                                            {
                                                logisticDetail.display_origin_address.address1 ? `${logisticDetail.display_origin_address.address1}, ` : ''
                                            }
                                            {
                                                logisticDetail.display_origin_address.address2 ? `${logisticDetail.display_origin_address.address2}, ` : ''
                                            }
                                            {
                                                logisticDetail.display_origin_address.landmark ? `${logisticDetail.display_origin_address.landmark}, ` : ''
                                            }
                                            {
                                                logisticDetail.display_origin_address.city ? `${logisticDetail.display_origin_address.city}, ` : ''
                                            }
                                            </label><br />
                                            <label className='form-label'>Origin of Supply : 
                                                <span>
                                                {
                                                    logisticDetail.display_origin_address.state ? logisticDetail.display_origin_address.state : ''
                                                }
                                                </span>
                                            </label> <br />
                                            <label className='form-label'>GSTIN : 
                                                <span>
                                                {
                                                    logisticDetail.display_origin_address.gstin ? logisticDetail.display_origin_address.gstin : ''
                                                }
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    : null
                                    ) 
                                }
                                {
                                    logisticDetail.origin_type === 'manual_entry' &&
                                    this.manualEntryJsx()
                                }
                            </form>
                            }
                        </div>
                        {
                            this.state.logisticDetail.origin_type !== 'manual_entry' &&
                            <div className="modal-footer">
                                <button type="button" disabled={this.state.editFormSubmitting} className="btn btn-secondary mx-2" data-bs-dismiss="modal">Cancel</button>
                                <button type="submit" disabled={this.state.editFormSubmitting} className="btn btn-primary" form="editOriginLogisticForm">
                                    Submit {this.state.editFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }

    editOriginManualAddressSubmit             =   (e)  =>  {
        e.preventDefault();
        this.setState({editFormSubmitting : true});

        const logisticDetail    =   this.state.logisticDetail;
        const data = {
            origin_type : logisticDetail.origin_type, 
            origin_address : this.state.manualAddress, 
            id : this.state.logisticDetail.id,

        }
        HttpAPICall.withAthorization('PUT', `${this.logisticUrl}/edit`, this.props.access_token, null, data, (response) => {
             toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
             this.props.getLogisticViewDetails(logisticDetail.transaction_id);
             this.addModal.hide();
         }).then(() => this.setState({ editFormSubmitting: false }));
 


    };   


    manualEntryJsx                  =    ()  =>  {
        return (
            <Ax>
                <form id="editManualAddress" method="post" encType="multipart/form-data">
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label">Address Line 1</label>
                        </div>
                        <div className="col-sm-6">
                            <input
                                name="address1"
                                type="text"
                                className="form-control"
                                value={this.state.manualAddress.address1}
                                onChange={(e) => this.formInputHandler(e, 'manualAddress')}
                                autoComplete="off"
                                maxLength="250"
                                placeholder="Please Enter Address Line 1"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label">Address Line 2</label>
                        </div>
                        <div className="col-sm-6">
                            <input
                                name="address2"
                                type="text"
                                className="form-control"
                                value={this.state.manualAddress.address2}
                                onChange={(e) => this.formInputHandler(e, 'manualAddress')}
                                autoComplete="off"
                                maxLength="250"
                                placeholder="Please Enter Address Line 2"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label">Landmark</label>
                        </div>
                        <div className="col-sm-6">
                            <input
                                name="landmark"
                                type="text"
                                className="form-control"
                                value={this.state.manualAddress.landmark}
                                onChange={(e) => this.formInputHandler(e, 'manualAddress')}
                                autoComplete="off"
                                maxLength="250"
                                placeholder="Please Enter Landmark"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label">City</label>
                        </div>
                        <div className="col-sm-6">
                            <input
                                name="city"
                                type="text"
                                className="form-control"
                                value={this.state.manualAddress.city}
                                onChange={(e) => this.formInputHandler(e, 'manualAddress')}
                                autoComplete="off"
                                maxLength="250"
                                placeholder="Please Enter City"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label">Country</label>
                        </div>
                        <div className="col-sm-6">
                            <TapSelect
                                changeEvent={(selectedOption) => {
                                    this.tapSelectChange(selectedOption, 'manualAddress', 'country_id');
                                    this.countryChangeHandler(selectedOption)
                                }
                                }
                                options={this.state.allCountryList}
                                isSearchable={true}
                                isClearable={false}
                                value={this.state.allCountryList.find(m => m.value == this.state.manualAddress.country_id)}
                                placeholder="Please Select Country"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label require">State (Source of Supply)</label>
                        </div>
                        <div className="col-sm-6">
                            <TapSelect
                                changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'manualAddress', 'state_id'); this.stateChangeHandler(selectedOption) }}
                                options={this.state.allStateList}
                                isSearchable={true}
                                isClearable={true}
                                required={true}
                                value={this.state.allStateList.find(m => m.value == this.state.manualAddress.state_id)}
                                placeholder="Please Select State"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label">District</label>
                        </div>
                        <div className="col-sm-6">
                            {this.state.addNewDistrict
                                ? <input
                                    name="district_name"
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={this.state.manualAddress.district_name}
                                    onChange={(e) => this.formInputHandler(e, 'manualAddress')}
                                    maxLength="20"
                                    placeholder="Please Enter District"
                                />
                                : <TapSelect
                                    changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'manualAddress', 'district_name'); this.districtChangeHandler(selectedOption) }}
                                    options={this.state.allDistrictList}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={this.state.allDistrictList.find(m => m.value == this.state.manualAddress.district_name)}
                                    placeholder="Please Select District"
                                />}
                        </div>
                        <div className="col-sm-2">
                            <input
                                name="addNewDistrict"
                                type="checkbox"
                                value={this.state.addNewDistrict}
                                onChange={(e) => {
                                    this.setState({
                                        addNewDistrict: !this.state.addNewDistrict,
                                        manualAddress: { ...this.state.manualAddress, district_id: '', pincode: '' }
                                    })
                                }}
                                checked={this.state.addNewDistrict}
                                className="form-check-input"
                                id="newDistrict"
                            />
                            <label className="form-check-label mx-2 " htmlFor="newDistrict">Add New </label>
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label">PIN Code</label>
                        </div>
                        <div className="col-sm-6">
                            {
                                this.state.addNewPinCode
                                ? <input
                                    name="pincode"
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={this.state.manualAddress.pincode}
                                    onChange={(e) => this.formInputHandler(e, 'manualAddress')}
                                    maxLength="20"
                                    placeholder="Please Enter PinCode"
                                />
                                : 
                                <TapSelect
                                    changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'manualAddress', 'pincode') }}
                                    options={this.state.allPincodeList}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={this.state.allPincodeList.find(m => m.value == this.state.manualAddress.pincode)}
                                    placeholder="Please Select PIN Code"
                                />
                            }
                        </div>
                        <div className="col-sm-2">
                            <input
                                name="addNewPinCode"
                                type="checkbox"
                                value={this.state.addNewPinCode}
                                onChange={(e) => {
                                    this.setState({
                                        addNewPinCode: !this.state.addNewPinCode,
                                        manualAddress: { ...this.state.manualAddress, pincode: '' }
                                    })
                                }}
                                checked={this.state.addNewPinCode}
                                className="form-check-input"
                                id="newPinCode"

                            />
                            <label className="form-check-label mx-2" htmlFor="newPinCode">Add New </label>
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label">GSTIN</label>
                        </div>
                        <div className="col-sm-6">
                            <input
                                name="gstin"
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={this.state.manualAddress.gstin}
                                onChange={(e) => this.formInputHandler(e, 'manualAddress')}
                                maxLength="20"
                                placeholder="Please Enter GSTIN Number"
                            />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" disabled={this.state.editFormSubmitting} className="btn btn-secondary mx-2" data-bs-dismiss="modal">Cancel</button>
                        <button onClick={this.editOriginManualAddressSubmit} disabled={this.state.editFormSubmitting} className="btn btn-primary" >
                            Submit {this.state.editFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                        </button>
                    </div>
                </form>
            </Ax>
        )
    }
    

    render() {
        return (<Ax>{this.modalJsx()}</Ax>);
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
    };
};

export default connect(mapStateToProps,null, null, { forwardRef: true })(OriginEditModal);